import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ECallActive {
  SetCallActive = 'callActive/set',
  ClearCallActive = 'callActive/clear',
}

export type TSetCallActive = ITypedReduxAction<ECallActive.SetCallActive>;
export type TClearCallActive = ITypedReduxAction<ECallActive.ClearCallActive>;

export type TCallActions = TSetCallActive | TClearCallActive;
